import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { PublicAuthModule } from './app/public-auth.module';
import { environment } from './environments/environment';
import { applyWhiteLabelApiBase } from './app/services/api-base.util';

applyWhiteLabelApiBase();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(PublicAuthModule)
  .catch((err) => console.error(err));
